// src/components/Admin/tabs/OrdersTab.jsx
// Pedidos pagados de la tienda. "Con reservación" = se entrega con el perro;
// "Envío" = mandar por paquetería a la dirección del pedido.
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateOrderStatusAdmin } from '../../../redux/slices/Admin/adminSlice';
import { formatMXN as money } from '../../../utils/store';

// Debe coincidir con el enum de status en macarios-api/model/Order.js
const STATUSES = ['PROCESANDO', 'ENVIADO', 'ENTREGADO', 'CANCELADO'];

const STATUS_STYLES = {
  PROCESANDO: 'bg-[#B08D57]/15 text-[#8A6A3A]',
  ENVIADO: 'bg-[#3A2A20]/10 text-[#3A2A20]',
  ENTREGADO: 'bg-[#3A6B4C]/10 text-[#3A6B4C]',
  CANCELADO: 'bg-[#9A0002]/10 text-[#9A0002]',
};

const formatDate = (date) =>
  date ? new Date(date).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

const OrdersTab = ({ orders }) => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState('pendientes'); // pendientes | todos
  const [error, setError] = useState('');

  const visible = filter === 'pendientes'
    ? orders.filter((o) => !['ENTREGADO', 'CANCELADO'].includes(o.status))
    : orders;

  const handleStatus = async (id, status) => {
    setError('');
    const result = await dispatch(updateOrderStatusAdmin({ id, status }));
    if (result.error) setError(result.payload || 'No se pudo actualizar el pedido');
  };

  return (
    <div>
      <div className="flex gap-2 mb-4">
        {[
          ['pendientes', 'Por entregar'],
          ['todos', 'Todos'],
        ].map(([key, label]) => (
          <button
            key={key}
            onClick={() => setFilter(key)}
            className={`px-3.5 py-1.5 rounded-lg text-sm font-medium transition ${
              filter === key ? 'bg-[#3A2A20] text-[#EFE6DD]' : 'bg-white text-[#3A2A20]/60 border border-[#3A2A20]/10'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {error && <p className="text-sm text-[#9A0002] mb-3">{error}</p>}

      {visible.length === 0 ? (
        <p className="text-sm text-[#3A2A20]/60">No hay pedidos {filter === 'pendientes' ? 'por entregar' : 'pagados'}.</p>
      ) : (
        <div className="grid gap-3">
          {visible.map((order) => (
            <div key={order._id} className="bg-white border border-[#3A2A20]/10 rounded-xl p-4 space-y-3">
              <div className="flex flex-wrap justify-between gap-3">
                <div>
                  <h3 className="font-semibold text-[#3A2A20]">
                    {order.orderNumber}
                    <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[order.status] || ''}`}>
                      {order.status}
                    </span>
                  </h3>
                  <p className="text-sm text-[#3A2A20]/60">
                    {order.user?.fullname} · {order.user?.email} · pagado {formatDate(order.paidAt)}
                  </p>
                </div>
                <select
                  value={order.status}
                  onChange={(e) => handleStatus(order._id, e.target.value)}
                  className="h-9 px-3 border border-[#3A2A20]/15 rounded-lg text-sm bg-white"
                >
                  {STATUSES.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>

              <ul className="text-sm text-[#3A2A20]">
                {order.items.map((item) => (
                  <li key={item._id || item.product}>
                    {item.quantity} × {item.nameAtTime} <span className="text-[#3A2A20]/50">({money(item.priceAtTime)})</span>
                  </li>
                ))}
              </ul>

              <div className="text-sm bg-[#EFE6DD]/40 rounded-lg p-3">
                {order.deliveryMethod === 'booking' ? (
                  <p>
                    <strong>Con reservación:</strong> entregar junto con el perro
                    {order.linkedBooking && <> (salida {formatDate(order.linkedBooking.checkOutDate)})</>}.
                  </p>
                ) : (
                  <p>
                    <strong>Envío a:</strong> {order.shippingAddress?.nombre} {order.shippingAddress?.paterno},{' '}
                    {order.shippingAddress?.direccion}, {order.shippingAddress?.colonia}, {order.shippingAddress?.delegacion},{' '}
                    {order.shippingAddress?.estado} {order.shippingAddress?.zipcode} · Tel. {order.shippingAddress?.telefono}
                  </p>
                )}
              </div>

              <p className="text-sm text-[#3A2A20]/70">
                Subtotal {money(order.subtotal)} · Envío {money(order.shippingCost)} · IVA {money(order.iva)} ·{' '}
                <strong className="text-[#3A2A20]">Total {money(order.totalPrice)}</strong>
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrdersTab;
